import { componentStyles } from "./whats-new-inner-page-side-by-side-text-and-asset-component.scss";
import SideBySideTextAndAssetComponent from "segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component";
import CardTag from "segments/desktop/core-components/card-tag/card-tag";
import DefaultProps from "./default-props";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import {WHATS_NEW_PAGE_LINK} from "constants/links";

const WhatsNewInnerPageSideBySideTextAndAssetComponent = (props) => {
  const { tags, date, asset, translate, ...resParagraphProps } = props;
  const formattedDate = new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });

  const renderTag = (tag) => {
    const { tagColor, tagText } = tag;
    return (
      <div className="tag-wrapper">
        <CardTag tagText={tagText} tagColor={tagColor} />
      </div>
    );
  };

  const RightSectionComponent = () => {
    const { rightSectionPaddingTop } = props;
    return (
      <div className="right-section" style={{ paddingTop: rightSectionPaddingTop }}>
        <div className="right-section-content">
          <div className="tags">{tags.map((tag) => renderTag(tag))}</div>
          <FullParagraph {...resParagraphProps} />
          <div className="date">{formattedDate}</div>
          <div className="share-post-section">{translate("whatsNewPage.innerPage.card.shareThisPost")}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="whats-new-inner-page-side-by-side-text-and-asset-component">
      <a className="back-to-releases" href={WHATS_NEW_PAGE_LINK}>
        <span className="back-arrow">{"<"}</span> Back to releases
      </a>
      <SideBySideTextAndAssetComponent
        swapTextAndAssetPosition={true}
        replaceTextComponent={RightSectionComponent}
        asset={asset}
      />
      <style jsx>{componentStyles}</style>
    </div>
  );
};

WhatsNewInnerPageSideBySideTextAndAssetComponent.defaultProps = DefaultProps;

export default WhatsNewInnerPageSideBySideTextAndAssetComponent;
